<template>
  <div>
    <list
      row-key="ExamStudentId"
      ref="list"
      unit="参加报名学生"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="false"
      :get-data-func="api.list"
      query-tip="提示：同一考场号的座位号保持位数相同，如01、02等等"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" placeholder="请输入姓名" clearable style="width:180px;"></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ExamHallNo" label="考场号"/>
        <el-table-column prop="SeatNo" label="座位号"/>
        <el-table-column prop="AdmissionNo" label="准考证号"/>
        <el-table-column prop="EnrollNo" label="报名序号"/>
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>
        <el-table-column prop="School" label="毕业学校" show-overflow-tooltip />
        <el-table-column prop="IdCard" label="证件号" min-width="135"/>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { 
    list,
  },
  data() {
    return {
      api: require("@/api/po/examstudent").default,
      params: {
        FullName: "",
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>

